import { render, staticRenderFns } from "./SignupLogin.vue?vue&type=template&id=443015ff&scoped=true&"
import script from "./SignupLogin.vue?vue&type=script&lang=js&"
export * from "./SignupLogin.vue?vue&type=script&lang=js&"
import style0 from "./SignupLogin.vue?vue&type=style&index=0&id=443015ff&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "443015ff",
  null
  
)

export default component.exports